import type { CSSProperties } from "react";
import { useMemo } from "react";
import { useTheme } from "@repo/tokens";

export const TRANSITION_MS = 250;
const EASING = "cubic-bezier(0.16, 1, 0.3, 1)";
const DURATION = `${TRANSITION_MS}ms`;

export const useStyles = () => {
  const { theme } = useTheme();

  return useMemo(() => {
    const styles = {
      root: {
        width: "100%",
      } as CSSProperties,

      item: {
        borderBottom: `1px solid ${theme.colors.neutral[90]}`,
      } as CSSProperties,

      trigger: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        gap: theme.spacing.sm,
        width: "100%",
        padding: `${theme.spacing.sm}px ${theme.spacing.md}px`,
        cursor: "pointer",
        border: "none",
        outline: "none",
        background: "transparent",
        fontFamily: "inherit",
        fontSize: "inherit",
        color: "inherit",
        textAlign: "left" as const,
      } as CSSProperties,

      triggerDisabled: {
        opacity: 0.5,
        cursor: "not-allowed",
      } as CSSProperties,

      triggerContent: {
        flex: 1,
        minWidth: 0,
      } as CSSProperties,

      contentGrid: (isExpanded: boolean) =>
        ({
          display: "grid",
          gridTemplateRows: isExpanded ? "1fr" : "0fr",
          transition: `grid-template-rows ${DURATION} ${EASING}`,
        }) as CSSProperties,

      contentOverflow: {
        overflow: "hidden",
        minHeight: 0,
      } as CSSProperties,

      contentInner: {
        paddingLeft: theme.spacing.md,
        paddingRight: theme.spacing.md,
        paddingBottom: theme.spacing.md,
      } as CSSProperties,

      chevron: (isExpanded: boolean) =>
        ({
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          transition: `transform ${DURATION} ${EASING}`,
          transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
        }) as CSSProperties,
    };

    return styles;
  }, [theme]);
};
